// Depends
import { route, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/addresses'

const locationRoutes = [
  route('create', '/create', Create, meta('Adicionar novo endereço', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar endereço', true, 'guest')),
  route('index', '/index', Index, meta('Lista de endereços', true, 'guest'))
]

export default locationRoutes



// WEBPACK FOOTER //
// ./src/app/settings/addresses/routes.js